import { useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { Estrellas } from '../reutilizables/estrellas/Estrellas'
import * as calificarVendedorService from '../servicios/calificarVendedorService'
import Error from '../ui/Error'
import styles from './Calificar.module.css'

const CALIFICACION_MIN_LENGTH = 20
const MAX_CARACTERES = 250

const Calificar = () => {
  const { idPedidoItem, idPublicacion, idVendedor } = useParams()
  const [error, setError] = useState({})
  const location = useLocation().pathname.split('/')[1]
  const esProducto = location === 'CalificarProducto'
  const titulo = esProducto
    ? 'Contanos qué te pareció el producto'
    : '¿Cómo fue la atención del vendedor?'

  const navigate = useNavigate()
  const { loginDataContext: { idUsuario: idUsuarioCalifica } = {} } = useAuth()
  const idPedidoItemParsed = parseInt(idPedidoItem)
  const idPublicacionParsed = parseInt(idPublicacion)
  const idVendedorParsed = parseInt(idVendedor)

  const [formData, setFormData] = useState({
    idPedidoItem: idPedidoItemParsed,
    idUsuarioCalifica: idUsuarioCalifica,
    calificacionAlVendedor: 0,
    calificacionAlItem: 0,
    comentario: '',
    idUsuarioCalificado: idVendedorParsed,
    idItem: idPublicacionParsed
  })

  const onSubmit = async (e) => {
    try {
      e.preventDefault()
      const nuevaCalificacion = {
        idPedidoItem: formData.idPedidoItem,
        idUsuarioCalifica: formData.idUsuarioCalifica,
        calificacionAlVendedor: formData.calificacionAlVendedor,
        calificacionAlItem: formData.calificacionAlItem,
        comentario: formData.comentario,
        idUsuarioCalificado: formData.idUsuarioCalificado,
        idItem: formData.idItem
      }

      const calificacion = esProducto
        ? formData.calificacionAlItem
        : formData.calificacionAlVendedor

      if (calificacion === 0 || formData.comentario === '') {
        setError({
          errores:
            calificacion === 0
              ? 'Por favor, ingresá una puntuación para la calificación.'
              : 'Por favor, escribí una opinión para la calificación.'
        })
        return
      } else if (formData.comentario.length < CALIFICACION_MIN_LENGTH) {
        setError({
          errores: 'Por favor, ingresá al menos 20 caracteres para tu opinión.'
        })
        return
      }

      const { data } = await calificarVendedorService.insertar(nuevaCalificacion)

      if (data?.resultado === false) {
        setError({
          errores: data.mensaje || 'Ya se calificó esta publicación'
        })
        return
      }

      setFormData((prev) => ({
        ...prev,
        idCalificacion: data.idCalificacion
      }))
      navigate('/Pedidos')
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar la calificación.`
      toastErrorLog(error, mensaje, 'calificacionVendedor')
    }
  }

  const handleStarClick = (estrella) => {
    const propiedad = esProducto ? 'calificacionAlItem' : 'calificacionAlVendedor'
    setFormData((prev) => ({
      ...prev,
      [propiedad]: estrella
    }))
    setError((prev) => ({
      ...prev,
      errores: ''
    }))
  }

  const onChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
    setError((prev) => ({
      ...prev,
      errores: ''
    }))
  }

  const volver = () => {
    navigate('/Pedidos')
  }

  return (
    <div className={styles.card}>
      <h3 className={styles.cardTitle}>Calificar Producto</h3>

      <div className={styles.contenedor}>
        <h4 className={styles.titulo}>{titulo}</h4>

        <form onSubmit={onSubmit} className={styles.formulario}>
          <Estrellas
            calificacion={
              esProducto ? formData.calificacionAlItem : formData.calificacionAlVendedor
            }
            handleStarClick={handleStarClick}
          />

          <div className={styles.contenedorErrorAlert}>
            <Error name="errores" errores={error} mostrarBordeError={false}>
              <label htmlFor="comentario" className={styles.labelComentario}>
                Tu opinión
              </label>
              <textarea
                onChange={onChange}
                className={styles.textarea}
                name="comentario"
                id="comentario"
                rows="4"
                maxLength={MAX_CARACTERES}
                placeholder="Contanos tu experiencia..."
              />
              <p className={styles.contadorDescripcion}>
                {formData.comentario?.length || 0} / {MAX_CARACTERES}
              </p>
            </Error>
          </div>

          <div className={styles.accionesRow}>
            <button
              className={`${styles.btnAccion} ${styles.btnVolver}`}
              onClick={volver}
              type="button"
            >
              Volver
            </button>
            <button type="submit" className={`${styles.btnAccion} ${styles.btnEnviar}`}>
              Enviá tu Opinión
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Calificar
